import { getUrlParams } from '../../../utils';

export const formItems = {
    applicantYearlyIncome: 'applicantYearlyIncome',
    applicantAge: 'applicantAge',
    mortageAmount: 'mortageAmount',
    mortgageType: 'mortgageType',
    hasPartnerIncome: 'hasPartnerIncome',
    partnerYearlyIncome: 'partnerYearlyIncome',
    partnerAge: 'partnerAge',
    monthlyCostsGross: 'monthlyCostsGross',
    monthlyCostsClean: 'monthlyCostsClean',
    ownMoney: 'ownMoney',
    askPrice: 'askPrice',
};
export interface DefaultValues {
    applicantAge: number;
    applicantYearlyIncome: number;
    partnerAge: number;
    partnerYearlyIncome: number;
    hasPartnerIncome: boolean;
    askPrice: number;
    askPriceNumber: number;
    ownMoney: null | number;
    monthlyCostsGross: number;
    monthlyCostsClean: number;
    postcode: string;
    huisnummer: string;
    huisNummerToevoeging: number;
    isNieuwBouw: boolean;
    mortageAmount: number;
}

export const getDefaultValues = (dataOverwrite: any = {}) => {
    const askPrice = getUrlParams('vraagprijs');
    const askPriceNumber = askPrice !== null && askPrice !== '' ? parseInt(askPrice) : 250000;
    const buildingType = getUrlParams('postcode');

    const data = {
        [formItems.applicantAge]: 35,
        [formItems.applicantYearlyIncome]: 40000,
        [formItems.partnerAge]: 35,
        [formItems.partnerYearlyIncome]: 40000,
        [formItems.hasPartnerIncome]: false,
        [formItems.askPrice]: askPriceNumber,
        [formItems.mortageAmount]: askPriceNumber,
        [formItems.ownMoney]: null,
        [formItems.monthlyCostsGross]: 0,
        [formItems.monthlyCostsClean]: 0,
        postcode: getUrlParams('postcode') || '',
        huisnummer: getUrlParams('huisnummer') || '',
        huisnummerToevoeging: getUrlParams('huisnummerToevoeging') || '',
        isNieuwBouw: buildingType != null && buildingType === 'nieuwbouw' ? true : false,
        ...dataOverwrite,
    };

    if (askPriceNumber - data[formItems.mortageAmount] > 0) {
        data[formItems.ownMoney] = askPriceNumber - data[formItems.mortageAmount];
    }

    if (data[formItems.mortageAmount] == null) {
        data[formItems.mortageAmount] = 10000;
    }

    return data;
};

export function transformCalculationDataForApi(data: any = {}) {
    let postData: { [id: string]: any } = {
        mortgageType: Number(data[formItems.mortgageType]),
        applicant: {
            age: Number(data[formItems.applicantAge]),
            yearlyIncome: Number(data[formItems.applicantYearlyIncome]),
            statePensionIncome: 0,
            oldAgePensionIncome: 0,
        },
        mortageAmount: Number(data[formItems.mortageAmount]),
        interestRate: 0.86,
        fixedInterestPeriod: 10,
        loans: 0,
        alimony: 0,
    };

    if (data[formItems.hasPartnerIncome] === 'true') {
        postData.partner = {
            age: Number(data[formItems.partnerAge]),
            yearlyIncome: Number(data[formItems.partnerYearlyIncome]),
            statePensionIncome: 0,
            oldAgePensionIncome: 0,
        };
    }

    return postData;
}
